// جميع نصوص الموقع في مكان واحد — عدّل من هنا فقط.

// ⚠️ استبدل هذه القيم بعد التسليم
export const WHATSAPP_NUMBER = "97339966793"; // بصيغة دولية بدون +
export const SOCIAL = {
  instagram: "https://instagram.com/",
  tiktok: "https://tiktok.com/",
  snapchat: "https://snapchat.com/",
} as const;

export const site = {
  brand: "ليان صوب",
  nav: {
    links: [
      { label: "الرئيسية", href: "#home" },
      { label: "عن ليان", href: "#about" },
      { label: "المكونات", href: "#ingredients" },
      { label: "المناسبات", href: "#occasions" },
      { label: "معرض ليان", href: "#gallery" },
      { label: "اطلب الآن", href: "#order" },
      { label: "الأسئلة الشائعة", href: "#faq" },
    ],
    whatsappAria: "تواصل عبر واتساب",
    menuAria: "فتح القائمة",
  },
  hero: {
    eyebrow: "صناعة يدوية · مكونات طبيعية 100%",
    h1: "توزيعات صابون طبيعي تليق بفخامة مناسبتك",
    sub: "في ليان صوب نحوّل الصابون الطبيعي المصنوع يدوياً بزبدة الشيا وجوز الهند إلى توزيعات أنيقة، تُغلَّف خصيصاً بثيم مناسبتك — من الأعراس إلى المواليد والتخرج.",
    ctaPrimary: "اطلب عبر واتساب",
    ctaSecondary: "شاهد أعمالنا",
    imageAlt: "توزيعات صابون طبيعي مغلّفة بشرائط ذهبية",
  },
  about: {
    kicker: "عن ليان",
    title: "قصة تبدأ من الطبيعة",
    body: "ليان صوب علامة متخصصة في صناعة الصابون الطبيعي يدوياً، بوصفات غنية بزبدة الشيا والجلسرين وزيت جوز الهند. نؤمن أن أجمل الهدايا هي التي تُصنع بعناية، لذلك نحوّل كل قطعة صابون إلى تفصيلة أنيقة تليق بمناسبتك — بتغليف يُصمَّم خصيصاً ليعكس ذوقك وثيم حفلك.",
    badges: ["صناعة يدوية 100%", "مكونات طبيعية آمنة", "تغليف حسب الطلب"],
  },
  ingredients: {
    title: "مكونات طبيعية تحبها بشرتك",
    items: [
      {
        name: "زيت الزيتون",
        text: "أساس الصابون الطبيعي؛ يغذّي البشرة ويمنحها ليونة ونعومة تدوم.",
        icon: "olive",
      },
      {
        name: "زبدة الكاكاو",
        text: "تُشكّل طبقة حماية ناعمة تحبس الترطيب وتترك رائحة دافئة راقية.",
        icon: "cocoa",
      },
      {
        name: "زبدة الشيا",
        text: "ترطيب عميق ونعومة تدوم؛ غذاء طبيعي متكامل للبشرة.",
        icon: "leaf",
      },
      {
        name: "الجلسرين",
        text: "يحافظ على رطوبة البشرة ويمنحها ملمساً حريرياً منتعشاً.",
        icon: "droplet",
      },
      {
        name: "زيت جوز الهند",
        text: "تنظيف لطيف ورغوة كريمية غنية بعطر هادئ.",
        icon: "sparkles",
      },
      {
        name: "زيت اللوز",
        text: "خفيف وسريع الامتصاص؛ يهدّئ البشرة الحساسة ويوازن نعومتها.",
        icon: "almond",
      },
      {
        name: "زيوت عطرية أساسية",
        text: "عطور طبيعية 100% مستخلصة من النباتات، بدون عطور صناعية.",
        icon: "aroma",
      },
      {
        name: "ألوان المايكا الطبيعية",
        text: "ألوان معدنية طبيعية آمنة تمنح القطعة لمعة أنيقة بلا أصباغ صناعية.",
        icon: "palette",
      },
    ],
  },

  occasions: {
    title: "توزيعات لكل مناسبة",
    sub: "نصمم التغليف والثيم حسب مناسبتك، بلمسة فاخرة تترك أثراً لدى ضيوفك.",
    linkLabel: "اطلب لهذه المناسبة",
    items: [
      {
        value: "زواج",
        title: "الأعراس والزواجات",
        text: "توزيعات راقية بثيم يليق بليلة العمر.",
        icon: "heart",
      },
      {
        value: "مولود",
        title: "المواليد",
        text: "هدايا ناعمة تحتفي بأجمل قادم.",
        icon: "baby",
      },
      {
        value: "تخرج",
        title: "التخرج",
        text: "لمسة فخر تليق بإنجازهم.",
        icon: "cap",
      },
      {
        value: "عيد ومواسم",
        title: "العيد والمواسم",
        text: "بهجة المواسم بتغليف مميز.",
        icon: "moon",
      },
      {
        value: "مناسبة عمل",
        title: "هدايا الشركات والضيافة",
        text: "انطباع راقٍ لعملائك وضيوفك.",
        icon: "gift",
      },
    ],
  },
  gallery: {
    title: "معرض ليان",
    sub: "لمحات من منتجاتنا وتغليفنا",
    closeLabel: "إغلاق",
  },
  how: {
    title: "اطلب في 3 خطوات",
    steps: [
      {
        title: "حدّد تفاصيل مناسبتك",
        text: "النوع والتاريخ وثيم التغليف والكمية.",
      },
      {
        title: "أرسلها عبر واتساب",
        text: "بضغطة واحدة تصلنا رسالة جاهزة بكل التفاصيل.",
      },
      {
        title: "نؤكد السعر ونبدأ التنفيذ",
        text: "تسعير حسب طلبك، وتجهيز بعناية يدوية كاملة.",
      },
    ],
  },
  order: {
    title: "صمّم طلبك الآن",
    sub: "اختر التفاصيل وسنستلمها فوراً على واتساب — الأسعار تُحدَّد حسب الطلب.",
    fields: {
      occasion: {
        label: "نوع المناسبة",
        placeholder: "اختر نوع المناسبة",
        error: "يرجى اختيار نوع المناسبة",
        options: ["زواج", "مولود", "تخرج", "عيد ومواسم", "مناسبة عمل", "أخرى"],
      },
      date: {
        label: "تاريخ المناسبة",
        placeholder: "اختر التاريخ",
        error: "يرجى تحديد تاريخ المناسبة",
      },
      theme: {
        label: "ثيم التغليف",
        placeholder: "اختر ثيم التغليف",
        error: "يرجى اختيار ثيم التغليف",
        options: [
          "كلاسيكي فاخر",
          "باستيل ناعم",
          "ذهبي ملكي",
          "أخضر طبيعي",
          "حسب ألوان الحفل",
        ],
      },
      soap: {
        label: "نوع الصابون",
        placeholder: "اختر نوع الصابون",
        error: "يرجى اختيار نوع الصابون",
        options: ["زبدة الشيا", "الجلسرين", "جوز الهند", "تشكيلة منوّعة"],
      },
      quantity: {
        label: "الكمية المطلوبة",
        placeholder: "اختر الكمية",
        error: "يرجى اختيار الكمية المطلوبة",
        options: ["25–50", "51–100", "101–200", "أكثر من 200"],
      },
      notes: {
        label: "ملاحظات إضافية",
        placeholder: "مثال: أرغب بإضافة بطاقات إهداء بأسماء الضيوف",
      },
    },
    submit: "أرسل الطلب عبر واتساب",
    microcopy: "لن يتم أي دفع الآن — سنتواصل معك لتأكيد السعر والتفاصيل.",
  },
  faq: {
    title: "الأسئلة الشائعة",
    items: [
      {
        q: "هل المنتجات طبيعية بالكامل؟",
        a: "نعم، صابوننا يُصنع يدوياً من مكونات طبيعية أساسها زبدة الشيا والجلسرين وزيت جوز الهند، دون مواد قاسية على البشرة.",
      },
      {
        q: "ما هي المكونات المستخدمة في الصابون؟",
        a: "نعتمد على مكونات طبيعية مختارة بعناية: زيت الزيتون، زبدة الكاكاو، زبدة الشيا، الجلسرين، زيت جوز الهند، وزيت اللوز — مع زيوت عطرية أساسية طبيعية وألوان المايكا الطبيعية، بدون أصباغ أو عطور صناعية.",
      },

      {
        q: "كيف يتم تحديد السعر؟",
        a: "يعتمد السعر على الكمية ونوع الصابون وثيم التغليف. بعد إرسال تفاصيل طلبك عبر واتساب نرسل لك عرض السعر النهائي.",
      },
      {
        q: "قبل كم يوم أحتاج أحجز طلبي؟",
        a: "نوصي بالحجز قبل موعد المناسبة بـ 7–14 يوماً حسب الكمية، لنضمن تجهيز كل قطعة وتغليفها بإتقان.",
      },
      {
        q: "هل يمكن تخصيص التغليف بثيم حفلي؟",
        a: "بالتأكيد. نصمم التغليف بألوان وثيم مناسبتك، مع إمكانية إضافة بطاقات إهداء أو عبارات خاصة.",
      },
      {
        q: "هل توفرون التوصيل؟",
        a: "نعم، تُحدَّد تفاصيل الشحن والمدة والتكلفة عند تأكيد الطلب عبر واتساب.",
      },
      {
        q: "هل تستقبلون طلبات الشركات والكميات الكبيرة؟",
        a: "نرحب بطلبات الشركات والفعاليات والضيافة، وتتوفر عروض خاصة للكميات الكبيرة.",
      },
    ],
  },
  footer: {
    tagline: "صابون طبيعي يدوي وتوزيعات تليق بمناسباتك.",
    quickTitle: "روابط سريعة",
    socialTitle: "تابعنا",
    copyright: "© 2026 ليان صوب — جميع الحقوق محفوظة",
  },
  whatsapp: {
    generic: "مرحباً ليان صوب 🌿 أرغب بالاستفسار عن توزيعات الصابون الطبيعي",
    stickyLabel: "تواصل واتساب الآن",
    fabAria: "تواصل عبر واتساب",
  },
  seo: {
    title: "ليان صوب | توزيعات صابون طبيعي فاخرة لجميع المناسبات",
    description:
      "صابون طبيعي صناعة يدوية بزبدة الشيا وجوز الهند — توزيعات مخصصة للأعراس والمواليد والتخرج والشركات، بتغليف يناسب ثيم مناسبتك. اطلب عبر واتساب.",
  },
} as const;

/** رقم دولي بدون + أو مسافات أو أصفار بادئة — wa.me لا يقبل غير الأرقام. */
const normalizedNumber = WHATSAPP_NUMBER.replace(/\D/g, "").replace(/^0+/, "");

export const whatsappLink = (message: string) =>
  `https://wa.me/${normalizedNumber}?text=${encodeURIComponent(message)}`;

/** يفتح واتساب مباشرة مع بديل آمن لو منع المتصفح النافذة المنبثقة. */
export const openWhatsApp = (message: string) => {
  const url = whatsappLink(message);
  const win = window.open(url, "_blank", "noopener,noreferrer");
  if (!win) window.location.href = url;
};

export const genericWhatsappLink = () => whatsappLink(site.whatsapp.generic);

